import { BigNumber } from "ethers";

const multi = 1.15;
const power = 100;

export const extraGas = (gas: BigNumber) =>
	gas.mul(Math.round(multi * power)).div(power);
